import { FilterState } from '../types';

export const areFiltersChecked = (values: FilterState): boolean => {
  if (values === null || values === undefined || typeof values !== 'object' || Array.isArray(values)) {
    return false;
  }

  const objectValues = Object.values(values);

  if (objectValues.length === 0) {
    return false;
  }

  for (const value of objectValues) {
    if (value !== null && value !== undefined) {
      if (Array.isArray(value)) {
        // An array is active if it's not empty and contains at least one non-nullish value.
        if (value.length > 0 && value.some((item) => item !== null && item !== undefined)) {
          return true;
        }
      } else {
        // Any non-null, non-undefined primitive is active.
        return true;
      }
    }
  }

  return false; // No active filter was found
};
